import { ERROR_MESSAGE_LOCATION } from '@/config/endpoints';
import rawMessages from '@@/error_messages.json';

interface MessageItem {
  code: string;
  message: string;
}

const typedMessages: MessageItem[] = rawMessages;

type MessageProps = {
  code: string;
  withCode?: boolean;
  className?: string;
};

const Message = ({ code, withCode = false, className }: MessageProps) => {
  const msg = typedMessages.find(m => m.code === code);

  return (
    <span
      className={className}
      dangerouslySetInnerHTML={{
        __html:
          msg && withCode
            ? `[${code}]: ${msg.message}`
            : msg
              ? msg.message
              : `Unknown code "${code}" was returned.
                Please report this error to the system administrator!
                If you are the system administrator, please update
                <a class="font-bold text-blue-500" href="${ERROR_MESSAGE_LOCATION}">this document</a>
                and add this errcode to it.`,
      }}
    />
  );
};

Message.displayName = 'Message';

export { Message };
